import type { ReactNode } from 'react'
import { Help } from '@/components/Form'
import styles from './IfFilter.module.css'

export interface IfFilterProps {
  /**
   * The {@link IfFilterBranch}es.
   */
  children?: ReactNode
}

/**
 * If (a filter) then (another filter) else (a third filter).
 */
export function IfFilter({ children }: IfFilterProps) {
  return <div className={styles.root}>{children}</div>
}

export interface IfFilterBranchProps {
  label: string
  /**
   * The branch's filter, or a button to pick one.
   */
  children?: ReactNode
  error?: string
}

/**
 * One of an {@link IfFilter}'s branches.
 */
export function IfFilterBranch({
  label,
  children,
  error,
}: IfFilterBranchProps) {
  return (
    <div className={styles.branch}>
      <span className={styles.branchLabel}>{label}</span>
      <div className={styles.branchBody}>
        {children}
        <Help error={error} />
      </div>
    </div>
  )
}
